export enum UsuarioSituacao {
  Ativo,
  Inativo,
  Todas
}
